import { NotFoundView } from 'src/sections/not-found/not-found-view';

export default function NotFoundPage() {
  return <NotFoundView />;
}
